import { createApi } from '@reduxjs/toolkit/query/react';
import { DatetimeDto, ResponseDto } from 'types';
import axiosBaseQuery from 'utils/base-api';

export const commonApi = createApi({
  reducerPath: 'commonApi',
  tagTypes: ['datetime'],
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    getDatetime: builder.query<ResponseDto<DatetimeDto>, null>({
      query: () => ({
        url: `/datetime`,
        method: 'GET'
      }),
      providesTags: ['datetime']
    })
  })
});

export const { useGetDatetimeQuery } = commonApi;
